<template>
  <div class="report-check">
    <div class="data-content">
      <div class="table-head">
        <div class="table-title">
          <span style="font-weight: bold">工具</span>
        </div>
       
      </div>
    </div>
    <div class="excel-reader" style="display: flex;">
        <div style="font-weight: bold; margin-right: 1em;">
             <span >批量发Co币/Co钻</span>
        </div>
        <div class="filter-item" style="width: 6rem; margin-right: 1em; ">
            <Select v-model="local_current_type" clearable style="min-width: 80px;">
                <Option
                  v-for="item in filterOption.currentTypeList"
                  :value="item.value"
                  :key="item.value">{{item.label }}
                </Option>
            </Select>
        </div>
        <div class="excel-reader" style="margin-left: 1em;">
           <Upload action="" :before-upload="handleBeforeUpload" loading = "loading" :multiple="false">
                <Button icon="ios-cloud-upload-outline">读取表格</Button>
            </Upload>
        </div>
        <Button  style="margin-left: 1em;" @click="toSubmit()">提交</Button>
    </div>
    <Table :columns="columns" :data="users">
      <template slot-scope="{ row, index }" slot="invite_code">
        <span>{{ row.invite_code }}</span>
      </template>
    
      <template slot-scope="{ row, index }" slot="count">
        <span>{{ row.count }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="days">
        <span>{{ row.days }}</span>
      </template>
    </Table>
  </div>
</template>

<script>
var XLSX = require('xlsx')
import apis from "../../http/api";
import commonApi from "../../utils/commonapi";
import { readFile } from "../../utils/excelRreadFile";


export default {
  name: "ReportCheck",
  props: {
        allowed: {
            type: Array,
            default () {
                //类型列表
                return [
                    'xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'xls', "application/vnd.ms-excel",
                    'csv', "text/csv"]
            },
        },
    },
  components: {},
  watch: {
  },
  data() {
    return {
        filterOption: {
          currentTypeList:[{'label':'Co币','value':0},{'label':'Co钻','value':1},{'label':'会员','value':99},{'label':'限时Co钻','value':98},{'label':'初心花','value':101}],
        },
        local_current_type:0,
        loading: false,
        users:[],
        canSubmit: true,
        baseColumns: [
          {
            title: 'invite_code',
            slot: 'invite_code',
            align: 'center'
          },
          {
            title: 'count',
            slot: 'count',
            align: 'center'
          },
        ],
    }

  },
  created() {
   
  },
  methods: {
    async handleBeforeUpload (file) {
        //选择文件后
        let _this = this

        _this.showLoading(true)

        //检测文件类型
        if (!_this.checkFileType(file)) {
          _this.$common.showMsg({
              type: 'error',
              content: `抱歉，请选择excel文件`,
          })

          _this.showLoading(false)
          return false
        }

        //选择excel文件后，并读取其内容（文件流）
        let dataBinary = await readFile(file)
        if (dataBinary != null) {
          // 将整个文件以二进制形式读取
          let workBook = XLSX.read(dataBinary, { type: 'binary', cellDates: true })

          // 工作表数量
          let workBookLen = workBook.SheetNames.length
          
          // excel工作簿内容
          let excelBook = []

          //读取每个sheets表
          for (let i = 0; i < workBookLen; i++) {
              let workSheet = workBook.Sheets[workBook.SheetNames[i]]
              excelBook.push({
                  sheetName: workBook.SheetNames[i],
                  data: XLSX.utils.sheet_to_json(workSheet, {
                  defval: null            //单元格为空时的默认值
                  , raw: false            //使用w的值而不是v
                  , dateNF: 'yyyy-MM-dd'   //日期格式
                  })
              })
          }

          _this.showLoading(false)
          console.log({
              name: file.name,
              length: workBookLen,
              data: excelBook
          })
          _this.users = []
          if(excelBook.length>0){
              console.log({list:excelBook[0].data})
              const isLimitedCoDiamond = _this.local_current_type === 98
              for(var i=0; i<excelBook[0].data.length;i++){
                  var item = excelBook[0].data[i]
                  // console.log("数据 = "+item.invite_code+","+item.count)
                  if(item.invite_code == undefined || item.invite_code === "" || (item.count-0)<=0){
                    break
                  }
                  if(isLimitedCoDiamond && (item.days == undefined || item.days === "" || (item.days-0)<=0)){
                    break
                  }
                  var userItem = {
                      invite_code:item.invite_code,
                      count:item.count-0
                  }
                  if(isLimitedCoDiamond){
                      userItem.days = item.days-0
                  }
                  _this.users.push(userItem)
              }
              console.log(_this.users)
          }
          //导出工作表内容
          _this.$emit("onChange", {
              name: file.name,
              length: workBookLen,
              data: excelBook
          })

        }
        // 禁止发起请求
        return Promise.reject()
    },
    toSubmit(){
        if(this.users.length == 0){
            this.$Message.error('请选择需要发币的用户！'); 
            return
        }
        const isLimitedCoDiamond = this.local_current_type === 98
        // 先读 Excel 再切到 98 时，列表可能没有有效 days
        if(isLimitedCoDiamond){
            const invalid = this.users.some(item => item.days == undefined || item.days === '' || (item.days - 0) <= 0)
            if(invalid){
                this.$Message.error('限时Co钻请重新上传含有效 days 的表格！');
                return
            }
        }
        // 非 98 只提交 invite_code、count，不带 days
        const submitData = this.users.map(item => {
          const row = {
            invite_code: item.invite_code,
            count: item.count
          }
          if(isLimitedCoDiamond){
            row.days = item.days - 0
          }
          return row
        })
        let params = {
          currency_type: this.local_current_type,
          data: submitData
        };
        if(this.canSubmit){
            this.canSubmit = false
            apis.tool_user_income_currency_send(params).then(res => {
              const { data, errCode, msg } = res;
              if (errCode === 0) {
                  commonApi.recordFromOperationToolCurrencySend(0,this.local_current_type, this.users.length)
                  this.users =[]
                  this.$Message.success('提交成功！'); 
                  this.canSubmit = true
              }else{
                alert(msg)
                this.canSubmit = true
              }
            }).catch(err => {
              alert("接口异常")
              this.canSubmit = true
            })
        }
    },
    showLoading (val) {
        let _this = this
        _this.loading = val
    },
    checkFileType (file) {
        let _this = this

        let flog = false

        //得到上传文件的值
        let fileName = file.name

        //取其类型
        let fileType = fileName.lastIndexOf('.')

        //返回位于String对象中指定位置的子字符串并转换为小写.
        let extension = fileName
          .substring(fileType)
          .toLowerCase()
          .replace('.', '')
        //判断允许上传的文件格式
        if (_this.allowed.includes(extension)) {
          flog = true
        } else {
          flog = false
        }

        return flog
    }
  },
  computed: {
    columns() {
      if (this.local_current_type === 98) {
        return [
          ...this.baseColumns,
          {
            title: 'days',
            slot: 'days',
            align: 'center'
          }
        ]
      }
      return this.baseColumns
    }
  },
  filters: {
  }
}
</script>

<style scoped>
    
.excel-reader {
    display: inline-block;
    .ant-upload-text {
    }
}
.report-check {
  margin: 10px;
}

.clickable-span {
  color: #1890ff;
  text-decoration: underline;
  cursor: pointer;
}

.text-center {
  text-align: center;
}

.table-head {
  display: flex;
  justify-content: space-between;
  padding-bottom: 5px;
}

.table-title {
  align-self: center;
}

.modal1-div {
  margin-bottom: 10px;
}

.info-pop {
  white-space: pre-wrap;
}
</style>
